export const CREDIT_FOR_FIRST_TIME_VVC = 25
